import Locale from "../../../output/Locale";

export function lookup(k) {
  const result = Locale.lookupNullable(k);
  if (!result) {
    console.error("unknown localization key", k);
  }
  return result;
}
